<template>
  <div id="reportes-poll-page" class="container-fluid">
    <div id="formulario-top" class="container">
      <div class="row">
        <div class="col-sm-2 col-sm-offset-2 col-xs-8 col-xs-offset-2">
          <date-picker :date="date" :option="option" @change="desde = $event"></date-picker>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <select-c name="ducto" id="ducto" placeholder="Ducto" :options="ductos" @changeSelect="chooseEstacion()"></select-c>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <select-c name="estacion" id="estacion" placeholder="Estacion" :options="estacionesOps"></select-c>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <button style="padding-left; 20px;" class="btn btn-default" @click="actualizar()" :class="[]"> ACTUALIZAR </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-xs-12" style="border-right:2px solid #999;">
          <div class="panel-body">
            <table class="table text-center">
              <thead>
                <tr class="text-center nombre-alarma">
                  <th style="width: 50% text-align:center!important;">Fecha
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </th>
                  <th style="width: 50% text-align:center!important;">Presión</th>
                </tr>
              </thead>
              <tbody v-for="(est, key) in estaciones" :id="'alarm-' + key" :key="key">
                <tr class="text-center">
                  <th style="width: 50%; text-align:center;">
                    {{est.date}}
                  </th>
                  <th style="width: 50%; text-align:center;">
                    {{est.pres}}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
    <button id="loading-btn" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal-modal"></button>
    <modal :name="info.modalName" cclass="transparent">
      <loading-modal :info="info"></loading-modal>
    </modal>
  </div>
</template>


<script>
  import SelectC from 'reusable/Select'
  import datePicker from 'vue-datepicker/vue-datepicker-es6.vue'
  let Modal = () => import('reusable/Modal')
  let LoadingModal = () => import('components/Modals/LoginModal')
  import toastr from 'toastr'

  export default {
    data() {
      return {
        info: {
          modalName: 'loading-modal'
        },
        date: this.$store.state.dpDate,
        option: this.$store.state.dpOpsFecha,
        desde: '',
        estaciones: [],
        estacionesOps : '',
        hasta: '',
        ductos: null
      }
    },
    methods: {
      chooseEstacion() {
        this.estacionesOps = this.$store.getters.GET_OP({
          filteredBy: 'sites',
          ducto: document.querySelector('#ducto').value
        })
      },
      loading() {
        document.querySelector('#loading-btn').click()
      },
      actualizar() {
        this.loading()
        if(this.desde === '') {
          this.desde = new Date().toLocaleString().split(',')
          this.desde = `${this.desde[0]} 00:00`
        }
        this.hasta = this.desde.split(' ')[0]
        this.hasta += ' 23:59'

        this.$store
        .dispatch('LOAD_PRESION', {
          lastTimestamp: -1,
          ducto: document.querySelector('#ducto').value,
          estacion: document.querySelector('#estacion').value,
          desde: this.desde || null,
          hasta: this.hasta || null
        })
        .then((resp) => {
          if(resp === 'no-data') {
            toastr.error('No se encontró información')
          } else {
            this.estaciones = []
            resp.data.forEach(r => {
              this.estaciones.push({
                date: r.formated_date,
                pres: r.pressure
              })
            })
          }
          this.loading()
        })
        .catch(err => {
          console.log(err)
        })
      }
    },
    components: {
      SelectC,
      datePicker,
      Modal,
      LoadingModal
    },
    mounted() {
      this.$store.dispatch('LOAD_OPS')
        .then(resp => {
          this.ductos = this.$store.getters.GET_OP({
            filteredBy: 'section_name'
          })
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

</script>

<style lang="scss" scoped>
  @import '~varmix';

  #formulario-top {
    margin-top: 75px;
    height: 12vh;
    @include celphone {
      height: 45vh;
    }
  }

  .row {
    // margin: 0;
  }

  .col-md-6,
  .col-xs-12 {
    padding: 0px !important;
  }

  .container-fluid {
    background-color: $gray;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  table,
  .panel-body {
    overflow: scroll;
    height: 65vh; // width: 50vw;
    padding: 0px 0;
    margin: 0;
    .info {
      td {
        background-color: $bg;
      }
    }
    th {
      text-align: center;
      padding-left: 25px;
      @include cMax(415px) {
        font-size: 12px;
      }
    }
    td {
      text-align: left;
      padding-left: 25px;
      i {
        color: $inactive;
        cursor: pointer;
        &:hover {
          color: $amarilloC;
        }
      }
    }
    .nombre-alarma {
      background-color: $amarilloC;
      color: white;
    }
    .panel-body {
      padding: 0;
    }
    .panel-title {
      @include cMax(415px) {
        font-size: 12px;
      }
    }
  }

  .btn-default {
    background: $amarilloO;
    &:hover,
    &:focus,
    &:active {
      background: $amarilloC !important;
    }
  }

  #reportes-page {
    padding-top: 70px;
    background-color: $bg;
    height:100vh;
    #formulario-top {
      height: 15vh;
      @include celphone {
        height: 45vh;
      }
    }

    #range-wrapper {
      margin: 50px auto;
    }
  } // range
  .color-2 .irs-bar,
  .color-2 .irs-bar-edge {
    background: red;
  }

  .panel {
    margin-bottom: 0;
  }

  .fa {
    margin-left: 3px;
    margin-top: 3px;
    @include cMax(1010px) {
      margin-top: -5px;
      margin-left: 13px;
    }
    @include tablet {
      margin-left: 3px;
      margin-top: 3px;
    }
    @include cMax(582px) {
      margin-top: -5px;
      margin-left: 13px;
    }
    @include cMax(415px) {
      margin-left: 12px;
      margin-top: 3px;
    }
  }

  .row {
    margin-right: 0px;
  }

  .no-show {
    display: none;
  }

  h3 {
    color: black;
    cursor: pointer;
  }

  span {
    padding: 0 20px;
    @include cMax(400px) {
      padding: 0 10px;
    }
  }

  table,
  .panel-body {
    background-color: $bg;
    overflow: scroll;
    height: 80vh;
    padding: 0;
    padding-left: 0px;
    border-top: 1px solid #999;
  }

  table {
    height: 35vh;
  }

  .not-active {
    color: $inactive;
  }

  .col-md-5,
  .col-md-7 {
    margin: 0;
    padding: 0;
  }


  .panel-default {
    background-color: $gray;
    border: none;
    border-radius: 0;
  }

  #data-table {
    position: absolute;
    color: $titles;
    width: 100vw;
    height: 30vh;
    bottom: 0;
  }

  #ductos {
    h3 {
      padding-left: 15px;
    }
    .ducto {
      color: white;
      font-size: 12px;
      cursor: pointer;
      background-color: $amarilloC;
    }
  }

  #alarmas {
    th {
      text-align: left;
      padding-left: 25px;
      @include cMax(415px) {
        font-size: 12px;
      }
    }
    td {
      text-align: left;
      padding-left: 25px;
      background-color: $bg;
      i {
        color: $inactive;
        cursor: pointer;
        &:hover {
          color: $amarilloC;
        }
      }
    }
    .nombre-alarma {
      background-color: $amarilloC;
      color: white;
    }
    .panel-body {
      padding: 0;
    }
    .panel-title {
      @include cMax(415px) {
        font-size: 12px;
      }
    }
  }

  #comentario-modal {
    h3 {
      color: $titles;
    }

    .btn-default {
      background-color: $amarilloC;
      &:hover,
      &:active,
      &:focus {
        background-color: $amarilloO !important;
      }
    }

    label {
      color: $amarilloC;
    }
    #label-name {
      color: white;
      width: 100%;
      font-size: 16px;
      padding: 5px;
      background-color: $amarilloC;
    }

    #selectDonde {
      -webkit-appearance: none;
      -webkit-border-radius: 0px;
      width: 80%;
      height: 40px;
      padding: 5px;
    }
  }
#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// Reportepoll.vue?02284932